import { Helmet } from 'react-helmet-async';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

const SCRIPT_SRC = 'https://widgets.givebutter.com/latest.umd.cjs?acct=EtoYNgiT72t0xEJZ&p=other';

/**
 * Loads the Givebutter widgets script once for the page.
 * Once loaded, the script registers `<givebutter-widget>` as a custom element,
 * so any subsequent instance mounted anywhere on the page (incl. inside a
 * portal/dialog) will initialize automatically via its connectedCallback.
 */
export function GivebutterScript() {
  return (
    <Helmet>
      <script src={SCRIPT_SRC} async></script>
    </Helmet>
  );
}

/**
 * Reusable modal that renders a Givebutter widget by ID.
 *
 * Note: we use a `key` tied to the open state so the custom element is
 * fully unmounted/remounted between opens — this avoids any half-initialized
 * widget state from a previous open.
 */
export default function GivebutterModal({ open, onOpenChange, widgetId, title, description }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl sm:max-w-3xl p-0 overflow-hidden bg-[#FAF3EE] border-0 max-h-[90vh]"
        data-testid={`gb-modal-${widgetId}`}
      >
        <DialogTitle className="sr-only">{title || 'Givebutter'}</DialogTitle>
        <DialogDescription className="sr-only">
          {description || 'Secure form powered by Givebutter.'}
        </DialogDescription>
        <div className="overflow-y-auto max-h-[90vh] p-3 sm:p-5">
          {open && (
            <givebutter-widget key={`${widgetId}-${open}`} id={widgetId}></givebutter-widget>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
